import { Box, Modal } from "@mui/material";
import React, { FC } from "react";

interface ModalTemplateProps {
  children: React.ReactNode;
  open: boolean;
  handleClose: () => void;
  className?: string;
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  overflow: "auto",
  maxHeight: "90vh",
  transform: "translate(-50%, -50%)",
  bgcolor: "#FFFBF5",
  boxShadow: 24,
  borderRadius: 2,
};

const ModalTemplate: FC<ModalTemplateProps> = ({
  children,
  open,
  handleClose,
  className = "",
}) => {
  return (
    <Modal onClose={handleClose} open={open}>
      <Box sx={style} className={className}>
        {children}
      </Box>
    </Modal>
  );
};

export default ModalTemplate;
